<section class="container-fluid">

  <form novalidate autocomplete="off" name="addMacroForm">
    <div class="row">
      <div class="col-sm-4 col-md-2"></div>
      <div class="col-sm-4 col-md-8">
        <div class="form-group ">
          <label class="lblCls">
            Name
          </label>
          <input type="text" kendoTextBox class="form-control" name="name" [(ngModel)]="addMacro.name" />
        </div>

        <div class="form-group ">
          <label class="lblCls">
            Description
          </label>
          <input type="text" kendoTextBox class="form-control" name="description" [(ngModel)]="addMacro.description" />
        </div>

        <div class="form-group ">
          <label class="lblCls">
            Expression
          </label>
          <!--<kendo-textarea [value]="textAreaWithRowsValue" [rows]="5"></kendo-textarea>-->
          <!--<input type="text" kendoTextBox class="form-control" name="expression" [(ngModel)]="addMacro.expression" />-->
          <textarea class="form-control" name="expression" [(ngModel)]="addMacro.expression"></textarea>
        </div>
        <div class="form-group ">
          <label class="lblCls">
            Old Expression
          </label>
          <textarea class="form-control" name="oldExpression" [(ngModel)]="addMacro.oldExpression"></textarea>
        </div>
        <div class="form-group">
          <label class="lblCls mr-2">
            Target
          </label>

          <kendo-dropdownlist class="kendoInput" name="target"  id="addmicroandedit"
                              [value]="{name:addMacro.target,value:addMacro.target}"
                              [(ngModel)]="addMacro.selectedtarget"
                              (valueChange)="targetValueChange($event,addMacro)"
                              (selectionChange)="targetSelectionChange($event,addMacro)"
                              [data]="targets"
                              textField="name" valueField="name"
                              [ngClass]="{'borderRed':false && isSubmitted}"
                              (blur)="validateForm()">
          </kendo-dropdownlist>
        </div>

        <div class="form-group">
          <label class="lblCls mr-2">
            Type
          </label>
          <kendo-dropdownlist class="kendoInput" name="type"  id="addmicroandedit"
                              [value]="{name:addMacro.type,value:addMacro.type}"
                              [(ngModel)]="addMacro.selectedType"
                              (valueChange)="typeValueChange($event,addMacro)"
                              (selectionChange)="typeSelectionChange($event,addMacro)"
                              [data]="types"
                              textField="name" valueField="name"
                              [ngClass]="{'borderRed':false && isSubmitted}"
                              (blur)="validateForm()">
          </kendo-dropdownlist>
        </div>

        <div class="form-group">
          <label class="lblCls mr-2">
            IsActive
          </label>
          <kendo-switch name="isActive" [(ngModel)]="addMacro.isActive" [onLabel]="'Yes'"
                        [offLabel]="'No'">
          </kendo-switch>
        </div>
        <div class="row">
          <div class="form-group">
            <div class="btn-group float-right" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="addMacroToSave()">
                Add<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      [routerLink]="['../']">
                Cancel
              </button>
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize">
                Validate
              </button>

            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4 col-md-2"></div>
    </div>
  </form>
</section>
